import React, { Component } from 'react'

export default class PrefixSuffix extends Component {
  handleChange = changes => {
    const { entity, onUpdate } = this.props
    const format = entity.format || {}

    onUpdate({
      ...entity,
      format: { ...format, ...changes },
    })
  }

  render() {
    const { entity } = this.props
    const format = entity.format || {}

    return (
      <div className="entity-detail-popout-columns">
        <Field
          name="prefixSingular"
          value={format.prefixSingular}
          onChange={this.handleChange}
          label="Singular Prefix"
        />
        <Field
          name="prefix"
          value={format.prefix}
          onChange={this.handleChange}
          label="Plural Prefix"
        />
        <Field
          name="suffixSingular"
          value={format.suffixSingular}
          onChange={this.handleChange}
          label="Singular Suffix"
        />
        <Field
          name="suffix"
          value={format.suffix}
          onChange={this.handleChange}
          label="Plural Suffix"
        />
      </div>
    )
  }
}

class Field extends Component {
  handleKeyDown = e => {
    e.stopPropagation()
  }

  handleChange = e => {
    const value = e.currentTarget.value
    const { name, onChange } = this.props

    onChange({ [name]: value })
  }

  render() {
    const { label, value } = this.props

    return (
      <div className="entity-detail-popout-section">
        <p className="entity-detail-popout-label">{label}</p>
        <input
          className="entity-detail-popout-input"
          type="text"
          value={value || ''}
          onChange={this.handleChange}
          onKeyDown={this.handleKeyDown}
          onKeyUp={this.handleKeyDown}
          onKeyPress={this.handleKeyPress}
        />
      </div>
    )
  }
}
